import { createAction } from 'redux-actions';

export const changeTheme = createAction('CHANGE_THEME');
export const changeThemeToDark = createAction('CHANGE_THEME_TO_DARK');
export const changeThemeToLight = createAction('CHANGE_THEME_TO_LIGHT');
export const setClientLink = createAction('SET_CLIENT_LINK');
